export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-08.a36723c5.jpg";